import { FC, useEffect, useRef, useState, type JSX } from 'react';

import BasicField from '@payaca/components/basicField/BasicField';
import {
  InputStyleVariant,
  InputWidth,
} from '@payaca/components/inputWrapper/InputWrapper';
import { usePrevious } from '@payaca/hooks/usePrevious';
import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  styleVariant?: InputStyleVariant;
  initSearchTerm?: string;
  onSearchTermChange: (searchTerm?: string) => void;
  placeholder?: string;
  showSearchIcon?: boolean;
  inputWidthVariant?: InputWidth;
};
const SearchField: FC<Props> = ({
  styleVariant,
  initSearchTerm = '',
  placeholder,
  onSearchTermChange,
  showSearchIcon = true,
  inputWidthVariant,
}: Props): JSX.Element => {
  const searchTermRef = useRef<string>(initSearchTerm);
  const [searchTerm, setSearchTerm] = useState(initSearchTerm);
  const prevInitSearchTerm = usePrevious(initSearchTerm);

  useEffect(() => {
    if (prevInitSearchTerm !== initSearchTerm) {
      setSearchTerm(initSearchTerm);
    }
  }, [initSearchTerm, prevInitSearchTerm]);

  return (
    <div className="search-term-field-container grow">
      <BasicField
        inputWidth={inputWidthVariant}
        styleVariant={styleVariant}
        name="searchTerm"
        value={searchTerm}
        onChange={(value: { [key: string]: any }) => {
          searchTermRef.current = value.searchTerm;
          setSearchTerm(value.searchTerm);
        }}
        iconBefore={
          showSearchIcon ? <UntitledIcon name="search-lg.3" /> : undefined
        }
        onChangeTimeout={() => {
          onSearchTermChange(searchTermRef.current);
        }}
        placeholder={placeholder}
      />
    </div>
  );
};

export default SearchField;
